import {
  useGetUserProjectBasedLearnings,
  useDeleteProjectBasedLearning,
  getGetUserProjectBasedLearningsQueryKey,
  useGetTopProjectBasedLearnings,
  likeProjectBasedLearning,
  unlikeProjectBasedLearning,
  getGetTopProjectBasedLearningsQueryKey,
} from "@packages/api/madlenAPI";
import ProjectBasedLearningCard from "../../components/project-based-learning/ProjectBasedLearningCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { ProjectBasedLearningResponseDto } from "@packages/api/madlenAPI.schemas";

interface ExtendedProjectBasedLearningResponseDto
  extends ProjectBasedLearningResponseDto {
  isEditable?: boolean;
}

const ProjectBasedLearningDetailComponent = ({
  tool,
}: {
  tool: ExtendedProjectBasedLearningResponseDto;
}) => {
  return (
    <ProjectBasedLearningCard project={tool} isEditable={tool.isEditable} />
  );
};

const ProjectBasedLearningView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserProjectBasedLearnings}
      useDeleteTool={useDeleteProjectBasedLearning}
      getGetToolsQueryKey={getGetUserProjectBasedLearningsQueryKey}
      useGetTopTools={useGetTopProjectBasedLearnings}
      likeTool={likeProjectBasedLearning}
      unlikeTool={unlikeProjectBasedLearning}
      getGetTopToolsQueryKey={getGetTopProjectBasedLearningsQueryKey}
      toolType="projectBasedLearning"
      toolPath="project-based-learning"
      DetailComponent={ProjectBasedLearningDetailComponent}
      colors={{
        light: "from-red-400 to-pink-500",
        dark: "dark:from-red-300 dark:to-pink-400",
        iconBg: "bg-red-100 dark:bg-red-900/50",
        iconColor: "text-red-500 dark:text-red-300",
        hover: "hover:bg-red-50 dark:hover:bg-red-900/20",
      }}
      toolColor="red"
      gradientColor="teal"
    />
  );
};

export default ProjectBasedLearningView;
